import { LoadableAfterPaint } from '@confluence/loadable';

export const EditorBreadcrumbs = LoadableAfterPaint({
	loader: async () => {
		const { EditorBreadcrumbsComponent } = await import(
			/* webpackChunkName: "loadable-EditorBreadcrumbs" */ '../src/EditorBreadcrumbs'
		);
		return EditorBreadcrumbsComponent;
	},
});
